import React, { Component } from 'react';
import './styles.css';
import PropTypes from 'prop-types'
class TableRowGroup extends Component {
  render() {
    return (
      <div className="TableRowGroup">
        {this.props.children}
      </div>
    );
  }
}
TableRowGroup.propTypes = {
  children: PropTypes.any.isRequired
}
export default TableRowGroup;
